import { useEffect } from 'react';
import { useDispatch, useSelector } from 'shared/hooks';
import analytics from 'shared/utility/analytics';
import CheckboxWithCurrencyInput from 'shared/inputs/CheckboxWithCurrencyInput';
import Heading  from 'shared/components/Heading';
import LabelText  from 'shared/components/LabelText';
import InputsContainer from 'shared/containers/InputsContainer';
import { SYNC, sync } from 'shared/wizard/actions';
import {RadioSwitch, CurrencyInput, SelectInput} from "shared/inputs";

const WizardLanding = () => {
  const dispatch = useDispatch();
  const {
    input: { energy_label, purchase_price, new_house, new_regulations },
    output: { errors },
    meta: { energy_labels, energy_labels_next_year },
  } = useSelector(state => state);
  useEffect(() => {
    dispatch({
      type: SYNC,
      syncing: false,
    });
    analytics.send('Navigeer', 'Voorpagina');
  }, []);

  return (
    <>
      <Heading>Woning en (spaar)geld</Heading>
      <InputsContainer>
        <LabelText>Wat is de koopprijs van de woning die je op het oog hebt?</LabelText>
        <CurrencyInput
          id="purchase_price"
          onChange={sync(dispatch)('purchase_price')}
          value={purchase_price}
          errors={errors.purchase_price}
          placeholder="Aankoopbedrag"
        />
        <LabelText>Wat is het energielabel van de woning die je op het oog hebt?</LabelText>
        <SelectInput
          options={new_regulations ? energy_labels_next_year : energy_labels}
          value={energy_label}
          onChange={e => sync(dispatch)('energy_label', e.value)}
          placeholder="Energielabel"
          errors={Boolean(errors?.energy_label)}
        />
        <LabelText>Is de woning die je op het oog hebt een nieuwbouw woning?</LabelText>
        <RadioSwitch
          name="new_house"
          onChangeHandler={sync(dispatch)('new_house')}
          checked={new_house}
          errors={errors.new_house}
        />
        <CheckboxWithCurrencyInput
          css={{ '> div:first-of-type > div': { marginTop: '32px' } }}
          name="surplus_value"
          placeholder="Bedrag (winst)"
          label="Mijn vorige woning is met winst verkocht. (Dit wordt ook wel overwaarde genoemd)."
        />
        <CheckboxWithCurrencyInput name="own_resources" label="Ik wil spaargeld inleggen." />
      </InputsContainer>
    </>
  );
};

export default WizardLanding;
